import { c as _c } from "react/compiler-runtime";
import { SideMenuGroup } from '@/app/components/SideMenuGroup';
import { SideMenuItem } from '@/app/components/SideMenuItem';
// import AccountTreeRounded from '@mui/icons-material/AccountTreeRounded'
import Announcement from '@mui/icons-material/Announcement';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DeveloperBoardRounded from '@mui/icons-material/DeveloperBoardRounded';
import DvrIcon from '@mui/icons-material/Dvr';
import EngineeringIcon from '@mui/icons-material/Engineering';
import Engineering from '@mui/icons-material/EngineeringRounded';
import FolderIcon from '@mui/icons-material/Folder';
import HomeIcon from '@mui/icons-material/Home';
import HubRounded from '@mui/icons-material/HubRounded';
import ListAlt from '@mui/icons-material/ListAlt';
import OilBarrel from '@mui/icons-material/OilBarrelRounded';
import PrecisionManufacturing from '@mui/icons-material/PrecisionManufacturingRounded';
import QuestionAnswer from '@mui/icons-material/QuestionAnswer';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SettingsApplications from '@mui/icons-material/SettingsApplicationsRounded';
import Source from '@mui/icons-material/SourceRounded';
import TableChartIcon from '@mui/icons-material/TableChart';
import Warehouse from '@mui/icons-material/WarehouseRounded';
import Work from '@mui/icons-material/WorkOutline';
import Badge from '@mui/material/Badge';
import * as colors from '@mui/material/colors';
import { ROUTES } from '@shared/routes';
import { useSearchParams } from 'next/navigation';
import { type FC } from 'react';
interface SideMenuPages {
  isMenuOpen: boolean;
  hasJmtAccess?: boolean;
  hasQmtAccess?: boolean;
  qmtLabel?: string;
}
const QmtMenuItem: FC<{
  isMenuOpen: boolean;
  label?: string;
}> = t0 => {
  const $ = _c(4);
  const {
    isMenuOpen,
    label: t1
  } = t0;
  const label = t1 === undefined ? "Opportunity List" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <RequestQuoteIcon />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isMenuOpen || $[2] !== label) {
    t3 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t2} route={ROUTES.opt.base}>{label}</SideMenuItem>;
    $[1] = isMenuOpen;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
const CommonPages: FC<SideMenuPages> = t0 => {
  const $ = _c(17);
  const {
    isMenuOpen,
    hasJmtAccess,
    hasQmtAccess,
    qmtLabel
  } = t0;
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.toString();
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const jobsRoute = `${ROUTES.jobs.base}?${t1}`;
  const showJmtAccess = hasJmtAccess ?? true;
  const showQmtAccess = hasQmtAccess ?? false;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HomeIcon />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isMenuOpen) {
    t3 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t2} route={ROUTES.home}>Home</SideMenuItem>;
    $[3] = isMenuOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isMenuOpen || $[6] !== qmtLabel || $[7] !== showQmtAccess) {
    t4 = showQmtAccess && <QmtMenuItem isMenuOpen={isMenuOpen} label={qmtLabel} />;
    $[5] = isMenuOpen;
    $[6] = qmtLabel;
    $[7] = showQmtAccess;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isMenuOpen || $[10] !== jobsRoute || $[11] !== showJmtAccess) {
    t5 = showJmtAccess && <><SideMenuItem isMenuOpen={isMenuOpen} icon={<Work />} route={jobsRoute}>Job List</SideMenuItem><SideMenuItem isMenuOpen={isMenuOpen} icon={<ListAlt />} route={ROUTES.sheets.base}>PPT List</SideMenuItem></>;
    $[9] = isMenuOpen;
    $[10] = jobsRoute;
    $[11] = showJmtAccess;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export const GuestPages: FC<SideMenuPages> = t0 => {
  const $ = _c(4);
  const {
    isMenuOpen,
    hasJmtAccess,
    hasQmtAccess
  } = t0;
  let t1;
  if ($[0] !== hasJmtAccess || $[1] !== hasQmtAccess || $[2] !== isMenuOpen) {
    t1 = <CommonPages isMenuOpen={isMenuOpen} hasJmtAccess={hasJmtAccess} hasQmtAccess={hasQmtAccess} />;
    $[0] = hasJmtAccess;
    $[1] = hasQmtAccess;
    $[2] = isMenuOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export const UserPages: FC<SideMenuPages> = t0 => {
  const $ = _c(5);
  const {
    isMenuOpen,
    hasJmtAccess,
    hasQmtAccess,
    qmtLabel
  } = t0;
  let t1;
  if ($[0] !== hasJmtAccess || $[1] !== hasQmtAccess || $[2] !== isMenuOpen || $[3] !== qmtLabel) {
    t1 = <><CommonPages isMenuOpen={isMenuOpen} hasJmtAccess={hasJmtAccess} hasQmtAccess={hasQmtAccess} qmtLabel={qmtLabel} /></>;
    $[0] = hasJmtAccess;
    $[1] = hasQmtAccess;
    $[2] = isMenuOpen;
    $[3] = qmtLabel;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export const SiteManagerPages: FC<SideMenuPages> = t0 => {
  const $ = _c(14);
  const {
    isMenuOpen,
    hasJmtAccess,
    hasQmtAccess
  } = t0;
  let t1;
  if ($[0] !== hasJmtAccess || $[1] !== hasQmtAccess || $[2] !== isMenuOpen) {
    t1 = <UserPages isMenuOpen={isMenuOpen} hasJmtAccess={hasJmtAccess} hasQmtAccess={hasQmtAccess} qmtLabel="QMT" />;
    $[0] = hasJmtAccess;
    $[1] = hasQmtAccess;
    $[2] = isMenuOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Source />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isMenuOpen) {
    t3 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t2} route={ROUTES.operationFamilies.base}>Recipes</SideMenuItem>;
    $[5] = isMenuOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PrecisionManufacturing />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isMenuOpen) {
    t5 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t4} route={ROUTES.workstations.base}>Workstations</SideMenuItem>;
    $[8] = isMenuOpen;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t5) {
    t6 = <>{t1}{t3}{t5}</>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export const AdminPages: FC<SideMenuPages & {
  newSuggestionsCount?: number;
}> = t0 => {
  const $ = _c(84);
  const {
    isMenuOpen,
    newSuggestionsCount
  } = t0;
  let t1;
  if ($[0] !== isMenuOpen) {
    t1 = <UserPages isMenuOpen={isMenuOpen} hasJmtAccess={true} hasQmtAccess={true} />;
    $[0] = isMenuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AttachMoneyIcon />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DvrIcon />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isMenuOpen) {
    t4 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t3} route={ROUTES.opt.operations}>Operations</SideMenuItem>;
    $[4] = isMenuOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FolderIcon />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isMenuOpen) {
    t6 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t5} route={ROUTES.opt.technologies}>Technologies</SideMenuItem>;
    $[7] = isMenuOpen;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SavedSearchIcon />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isMenuOpen) {
    t8 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t7} route={ROUTES.opt.lookupTables}>Lookup Tables</SideMenuItem>;
    $[10] = isMenuOpen;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TableChartIcon />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isMenuOpen) {
    t10 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t9} route={ROUTES.opt.dataStore}>Data Store</SideMenuItem>;
    $[13] = isMenuOpen;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ChecklistIcon />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== isMenuOpen) {
    t12 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t11} route={ROUTES.opt.coreFormulas}>Core Formulas</SideMenuItem>;
    $[16] = isMenuOpen;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <QuestionAnswer />;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== isMenuOpen) {
    t14 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t13} route={ROUTES.opt.suggestions}>QMT Suggestions</SideMenuItem>;
    $[19] = isMenuOpen;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== isMenuOpen || $[22] !== t10 || $[23] !== t12 || $[24] !== t14 || $[25] !== t4 || $[26] !== t6 || $[27] !== t8) {
    t15 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t2} title="Pricing Admin">{t4}{t6}{t8}{t10}{t12}{t14}</SideMenuGroup>;
    $[21] = isMenuOpen;
    $[22] = t10;
    $[23] = t12;
    $[24] = t14;
    $[25] = t4;
    $[26] = t6;
    $[27] = t8;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <EngineeringIcon />;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <DeveloperBoardRounded />;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== isMenuOpen) {
    t18 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t17} route={ROUTES.operations.base}>Operations</SideMenuItem>;
    $[31] = isMenuOpen;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Source />;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== isMenuOpen) {
    t20 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t19} route={ROUTES.operationFamilies.base}>Recipes</SideMenuItem>;
    $[34] = isMenuOpen;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <HubRounded />;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== isMenuOpen) {
    t22 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t21} route={ROUTES.core.base}>Core Sections</SideMenuItem>;
    $[37] = isMenuOpen;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <SettingsApplications />;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== isMenuOpen) {
    t24 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t23} route={ROUTES.template.edit}>Edit PPT Template</SideMenuItem>;
    $[40] = isMenuOpen;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== isMenuOpen || $[43] !== t18 || $[44] !== t20 || $[45] !== t22 || $[46] !== t24) {
    t25 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t16} title="Job Admin">{t18}{t20}{t22}{t24}</SideMenuGroup>;
    $[42] = isMenuOpen;
    $[43] = t18;
    $[44] = t20;
    $[45] = t22;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== newSuggestionsCount) {
    t26 = newSuggestionsCount ? <Badge badgeContent={newSuggestionsCount} color="secondary" max={99}><AssuredWorkloadIcon sx={{
        color: colors.yellow[500]
      }} /></Badge> : <AssuredWorkloadIcon />;
    $[48] = newSuggestionsCount;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Warehouse />;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== isMenuOpen) {
    t28 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t27} route={ROUTES.sites.base}>Sites</SideMenuItem>;
    $[51] = isMenuOpen;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <OilBarrel />;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== isMenuOpen) {
    t30 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t29} route={ROUTES.materialTypes.base}>Materials</SideMenuItem>;
    $[54] = isMenuOpen;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Engineering />;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== isMenuOpen) {
    t32 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t31} route={ROUTES.engineers.base}>Engineers</SideMenuItem>;
    $[57] = isMenuOpen;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <PrecisionManufacturing />;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== isMenuOpen) {
    t34 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t33} route={ROUTES.workstations.base}>Workstations</SideMenuItem>;
    $[60] = isMenuOpen;
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <ScheduleIcon />;
    $[62] = t35;
  } else {
    t35 = $[62];
  }
  let t36;
  if ($[63] !== isMenuOpen) {
    t36 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t35} route={ROUTES.jobDelayReasons.base}>Job Delay Reasons</SideMenuItem>;
    $[63] = isMenuOpen;
    $[64] = t36;
  } else {
    t36 = $[64];
  }
  let t37;
  if ($[65] !== newSuggestionsCount) {
    t37 = newSuggestionsCount ? <Badge badgeContent={newSuggestionsCount} color="secondary" max={99}><Announcement sx={{
        color: colors.yellow[500]
      }} /></Badge> : <QuestionAnswer />;
    $[65] = newSuggestionsCount;
    $[66] = t37;
  } else {
    t37 = $[66];
  }
  let t38;
  if ($[67] !== isMenuOpen || $[68] !== t37) {
    t38 = <SideMenuItem isMenuOpen={isMenuOpen} icon={t37} route={ROUTES.suggestions.base}>Suggestions</SideMenuItem>;
    $[67] = isMenuOpen;
    $[68] = t37;
    $[69] = t38;
  } else {
    t38 = $[69];
  }
  let t39;
  if ($[70] !== isMenuOpen || $[71] !== t26 || $[72] !== t28 || $[73] !== t30 || $[74] !== t32 || $[75] !== t34 || $[76] !== t36 || $[77] !== t38) {
    t39 = <SideMenuGroup isMenuOpen={isMenuOpen} icon={t26} title="General Admin">{t28}{t30}{t32}{t34}{t36}{t38}</SideMenuGroup>;
    $[70] = isMenuOpen;
    $[71] = t26;
    $[72] = t28;
    $[73] = t30;
    $[74] = t32;
    $[75] = t34;
    $[76] = t36;
    $[77] = t38;
    $[78] = t39;
  } else {
    t39 = $[78];
  }
  let t40;
  if ($[79] !== t1 || $[80] !== t15 || $[81] !== t25 || $[82] !== t39) {
    t40 = <>{t1}{t15}{t25}{t39}</>;
    $[79] = t1;
    $[80] = t15;
    $[81] = t25;
    $[82] = t39;
    $[83] = t40;
  } else {
    t40 = $[83];
  }
  return t40;
};